import { Component, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { TestsService } from '../../course/services/tests.service';
import {MetaService} from 'src/app/services/meta.service';

@Component({
  selector: 'acs-codes',
  templateUrl: './acs-codes.component.html',
  styleUrls: ['./acs-codes.component.scss']
})
export class AcsCodesComponent implements OnInit, OnDestroy {
  private metaService = inject(MetaService);

  @Input()
  course: any;

  @Input()
  user: any;

  activeCourse: string;
  isLoading = signal(true);
  acsCodes = [];
  courses = [
    { webAppId: "PRIVATE", name: "Private" },
    { webAppId: "INSTRUMENT", name: "Instrument" },
    { webAppId: "COMMERCIAL", name: "Commercial" }
  ]
  groupedAcsCodes: any;

  constructor(
    public testsService: TestsService
  ) {
  }

  ngOnInit(): void {
    this.metaService.addMetaTags('acsCodes');
    this.getAcsCodes(this.course.webAppId);
  }

  ngOnDestroy(): void {
    this.metaService.removeMetaTags();
  }

  getAcsCodes(webAppId: string) {
    this.activeCourse = webAppId;
    this.testsService.getCourseAcsSubTasks(webAppId).then((result) => {
      this.acsCodes = result;
      this.groupedAcsCodes = [];

      this.acsCodes.forEach((acsCode) => {
        const categoryLongCode = acsCode.categoryLongCode;

        const existingCategory = this.groupedAcsCodes.find(
          (category) => category.key === categoryLongCode
        );

        if (!existingCategory) {
          this.groupedAcsCodes.push({ key: categoryLongCode, value: [acsCode] });
        } else {
          existingCategory.value.push(acsCode);
        }
      });
      this.isLoading.set(false);
    });
  }

}
